import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/projects/', { params });
  },
  createData() {
    return Backend.get('/projects/create');
  },
  info(id) {
    return Backend.get(`/projects/${id}/info`);
  },
  editData(id) {
    return Backend.get(`/projects/${id}/edit`);
  },
  create(data) {
    return Backend.post('/projects/', data);
  },
  update(data) {
    return Backend.put(`/projects/${data.id}`, data);
  },
  delete(id) {
    return Backend.delete(`/projects/${id}`);
  },
};
